var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",function(){return [_c('input',{staticClass:"form-control",attrs:{"state":_vm.usdtEstimateInputState,"readonly":_vm.readonly},domProps:{"value":_vm.usdtEstimateString}})]},{"model":_vm.model,"result":_vm.usdtEstimateString,"dirty":_vm.model.rateDirty})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }